export default __webpack_public_path__ + "static/media/lefthand.69c3df73.png";